import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Machine } from '@/services/model/machine'
import { Roles, isAdminRole } from '@/services/repository/users'
import { anonCanAddFailure } from '@/env/config'
import { Spinner } from '@/components/spinner'
import { useAppContext } from '@/context/app'
import { useModal } from '@/components/modal/Modal'
import { ErrorCodesWizardPopup } from '../../ai/wizards/errorcodes/Main'

export interface DafaultMenuProps {
    machine: Machine
}

export const DafaultMenu = ({ machine }: DafaultMenuProps) => {
    const { services, session, translates } = useAppContext()
    const navigate = useNavigate()
    // const { redirectToLogin } = useLogin()
    const { openModal } = useModal()
    const fullAccess = isAdminRole(session?.user.role) || session?.user.role == Roles.CompanyAdmin || session?.user.role == Roles.Serviceman || session?.user.role == Roles.CompanyManager

    function forAnons() {
        if (!translates) {
            return <Spinner />
        }
        return null
        // return <div className='spaced-block'>
        //   <a className='main-red-btn' onClick={() => {
        //     redirectToLogin({
        //       redirectTo: `/communal/machine/${mid}`
        //     })
        //   }}>
        //     {translates.for('menus.communal.machine.login')}
        //   </a>
        // </div>
    }

    function forLoggedIn() {
        if (!translates || !session) {
            return <Spinner />
        }
        return <div>
            {fullAccess ? <>
                <a className='main-red-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/failures`) }}>
                    {translates.for('menus.communal.machine.failure_list')}
                </a>
                <a className='main-red-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/errors/can`) }}>
                    {translates.for('menus.communal.machine.can_errors')}
                </a>
            </> : null}
            {fullAccess || session?.user.role == Roles.User || session?.user.role == Roles.Operator ? <>
                {machine?.imei ? <>
                    <a className='main-red-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/hits`) }}>
                        {translates.for('menus.communal.machine.hits_list')}
                    </a>
                    <a className='main-red-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/hitmap`) }}>
                        {translates.for('menus.communal.machine.hits_map')}
                    </a>
                    <a className='main-red-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/pathmap`) }}>
                        {translates.for('menus.communal.machine.pathmap')}
                    </a>
                </> : null}
            </> : null}
        </div>
    }

    if (!machine || !translates) {
        return <Spinner />
    }

    return <div className="machine-menu-wrapper">
        {machine?.imei && fullAccess ? <>
            <a className='main-orange-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/session/dashboard`) }}>
                {translates.for('menus.communal.machine.session_dashboard')}
            </a>
        </> : null}

        {machine.checklistEnabled && (machine?.imei && fullAccess || session?.user.role == Roles.User || session?.user.role == Roles.Operator) ? <>
            <a className='main-orange-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/checklist/wizard`) }}>
                {translates.for('menus.communal.machine.checklist')}
            </a>
        </> : null}

        <a className='main-gray-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/details`) }}>
            {translates.for('menus.communal.machine.details')}
        </a>

        {fullAccess ? <>
            <a className='main-gray-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/service-details`) }}>
                {translates.for('menus.communal.machine.service_details')}
            </a>
            <a className='main-gray-btn' onClick={() => { navigate(`/communal/statistics/machines?machine=${machine.id}`) }}>
                {translates.for('menus.communal.machine.statistic_page')}
            </a>
        </> : null}

        {fullAccess ? <a className='main-gray-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/files`) }}>
            {translates.for('menus.communal.machine.files')}
        </a> : null}

        {anonCanAddFailure || session ? <a className='main-red-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/failures/add`) }}>
            {translates.for('menus.communal.machine.failure')}
        </a> : null}

        {!session ? forAnons() : forLoggedIn()}

        {fullAccess && machine.machineType?.manufacturer ? <a className='main-green-btn' onClick={() => { openModal((props) => ErrorCodesWizardPopup({ ...props, machineId: machine.id })) }}>
            {translates.for('menus.communal.machine.errorcode')}
        </a> : null}

        {fullAccess || session?.user.role == Roles.Serviceman ? <>
            <a className='main-btn' onClick={() => { navigate(`/communal/contact`) }}>
                {translates.for('menus.communal.machine.call')}
            </a>

            {session ? <a className='main-green-btn' onClick={() => { navigate(`/communal/support/wizard`) }}>
                {translates.for('menus.communal.machine.support_page')}
            </a> : null}
        </> : null}
    </div>
}
